import { useEffect } from 'react';
import stateContainer from 'src/lib/state';
import { useApp, useGlobalStateIn } from 'straightline-ui';

export const useAppState = () => useGlobalStateIn(stateContainer);

export const useOnMount = (fn) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useEffect(fn, []);
};

const twilioRootId = 'twilio-webchat-widget-root';

const clearChat = (rootElement, script) => {
  document.body.removeChild(rootElement);
  document.head.removeChild(script);
  delete window.Twilio;
  clearChatSession();
};

const clearChatSession = () => {
  localStorage.removeItem('NAME_COUNT');
  localStorage.removeItem('PARTICIPANTS_LIST');
  localStorage.removeItem('TWILIO_WEBCHAT_WIDGET');
  localStorage.removeItem('loglevel');
  localStorage.removeItem('loglevel:twilio-conversations');
  localStorage.removeItem('loglevel:twilio-notifications');
  localStorage.removeItem('loglevel:twilio-sync');
  localStorage.removeItem('loglevel:twilsock');
};

const setupChatSession = (appConfig) => {
  const rootElement = document.createElement('div');
  rootElement.id = twilioRootId;
  rootElement.style.position = 'relative';
  rootElement.style.zIndex = '5000';
  document.body.appendChild(rootElement);

  const script = document.createElement('script');
  script.src =
    'https://media.twiliocdn.com/sdk/js/webchat-v3/releases/3.3.0/webchat.min.js';
  script.integrity = 'sha256-ydLLXnNrb26iFUvKAHsYt9atwfzz0LNcgBmo0NmD5Uk=';
  script.crossOrigin = 'anonymous';
  document.head.appendChild(script);

  script.onload = () => {
    try {
      window.Twilio.initWebchat(appConfig);
    } catch (error) {
      console.log(error);
    }
  };

  return () => {
    try {
      clearChat(rootElement, script);
    } catch (e) {
      console.error(e);
    }
  };
};

export const useChat = () => {
  return;
  // eslint-disable-next-line no-unreachable
  const app = useApp();
  const {
    state: { authenticated }
  } = useAppState();

  const auth = app.auth;

  useEffect(() => {
    if (process.env.REACT_APP_ENVIRONMENT !== 'production') {
      return;
    }

    if (!authenticated || !auth) {
      return;
    }

    const appConfig = {
      deploymentKey: 'CVd5632edf439a02edd979586dcf5ba443',
      context: {
        token: auth.token,
        chat_type: 'SHIPPER',
        friendlyName: auth.user.full_name
      },
      // status: '',
      theme: {
        isLight: true
      },
      disablePreEngagementForm: false,
      preEngagementConfig: {
        title: <div style={{ marginBottom: '-35px' }}></div>,
        description:
          'If you have a question about a shipment please enter the shipment number below. Otherwise, leave it blank and ask us about something else.',
        submitLabel: "Let's chat",
        // footerLabel:
        //   "Don't worry, we don't use your info for marketing. This information is only used to help us assist you better.",
        fields: [
          {
            label: 'Shipment Number',
            type: 'InputItem',
            attributes: {
              name: 'shipment_id',
              type: 'text',
              pattern: '^#?\\d+$',
              placeholder: '#123456',
              required: false
            }
          },
          {
            label: 'Ask a question',
            type: 'TextareaItem',
            attributes: {
              name: 'query',
              type: 'text',
              placeholder: 'What can we do for you?',
              required: true
            }
          }
        ]
      }
    };

    const cleanupChat = setupChatSession(appConfig);

    return cleanupChat;
  }, [authenticated, auth]);
};

export const usePreviewTrack = (shipment, type) => {
  return;

  // eslint-disable-next-line no-unreachable
  useEffect(() => {
    if (process.env.REACT_APP_ENVIRONMENT !== 'production') {
      return;
    }

    if (!shipment?.id) {
      return;
    }

    const appConfig = {
      deploymentKey: 'CVd5632edf439a02edd979586dcf5ba443',
      context: {
        shipment_id: shipment.id,
        chat_type: type
        // token: auth.token,
      },
      // status: '',
      theme: {
        isLight: true
      },
      disablePreEngagementForm: false,
      preEngagementConfig: {
        title: <div style={{ marginBottom: '-35px' }}></div>,
        description:
          'Chat with us about this shipment. We can help you track it, make changes, or answer any questions you have.',
        submitLabel: "Let's chat",
        // footerLabel:
        //   "Don't worry, we don't use your info for marketing. This information is only used to help us assist you better.",
        fields: [
          {
            label: 'Full Name',
            type: 'InputItem',
            attributes: {
              name: 'friendlyName',
              type: 'text',
              // placeholder: '#123456',
              required: true
            }
          },
          {
            label: 'Email',
            type: 'InputItem',
            attributes: {
              name: 'email',
              type: 'email',
              // placeholder: 'you@example.com',
              required: true
            }
          },
          {
            label: 'Ask a question',
            type: 'TextareaItem',
            attributes: {
              name: 'query',
              type: 'text',
              // placeholder: 'What can we do for you?',
              required: true
            }
          }
        ]
      }
    };

    const cleanupChat = setupChatSession(appConfig);

    return cleanupChat;
  }, [shipment?.id, type]);
};
